import { connect } from "react-redux";
import { getBets, getCommunications, getRacesForTournament, getTicketsForRacesInCurrentTournament, getTournaments } from "../selectors";
import { tournamentImportPicks } from "../actions/tournament";
import ImportPicksLightBox from "../components/import-picks-light-box";

function select(state, props) {
  return {
    bets: getBets(state, props),
    communications: getCommunications(state),
    races: getRacesForTournament(state, props),
    ticketsForRacesInCurrentTournament: getTicketsForRacesInCurrentTournament(state, props),
    tournaments: getTournaments(state, props)
  };
}

export default connect(select, { tournamentImportPicks })(ImportPicksLightBox);

